import { AIDetectorDetailsType } from 'Plugins/AIDetector/AIDetector.plugin'
import PluginOkayIcon from 'Assets/icons/plugin-okay.svg'
import classes from '../AIDetector.module.less'
import { useMemo } from 'react'
import WarningFilled from '@ant-design/icons/lib/icons/WarningFilled'
import CheckCircleFilled from '@ant-design/icons/lib/icons/CheckCircleFilled'
import CloseCircleFilled from '@ant-design/icons/lib/icons/CloseCircleFilled'
import Divider from 'antd/lib/divider'

type AIDetectorDetailsPropsType = {
    details: AIDetectorDetailsType
    maxAIThreshold: number
}

export const AIDetectorDetails = (props: AIDetectorDetailsPropsType) => {
    const { details, maxAIThreshold } = props
    const { percentage, aiTexts } = details

    const aiTextsContent = useMemo(() => {
        if (aiTexts) {
            return (
                <div className={classes.aiTextsContent}>
                    <div className={classes.aiTextsCount}>
                        {aiTexts.length} parts seems to be AI generated
                    </div>
                    <div className={classes.divider} />
                    <div className={classes.aiTexts}>
                        {aiTexts.map((text, index) => (
                            <div className={classes.text} key={text + index}>
                                <p className={classes.textHeader}>
                                    <WarningFilled /> {index + 1}
                                </p>
                                <p className={classes.textContent}>{text}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )
        }

        return null
    }, [aiTexts])

    const aiCheckResults = useMemo(() => {
        if (percentage < maxAIThreshold) {
            return (
                <>
                    <CheckCircleFilled className={classes.checkIcon} />
                    <p className={classes.resultText + ' ' + classes.passed}>
                        Your answer passed our criteria for submission.
                    </p>
                </>
            )
        } else {
            return (
                <>
                    <CloseCircleFilled className={classes.crossIcon} />
                    <p className={classes.resultText + ' ' + classes.failed}>
                        Your answer didn't pass our criteria for submission.
                    </p>
                </>
            )
        }
    }, [maxAIThreshold, percentage])

    if (percentage === 0) {
        return (
            <div className={classes.noAIContentContainer}>
                <img src={PluginOkayIcon} alt={'No AI Content'} />
                <p>Great!! Your answer seems to be human-generated.</p>
            </div>
        )
    }

    return (
        <div className={classes.aiContentContainer}>
            <div className={classes.percentageContainer}>
                {aiCheckResults}
                <Divider className={classes.divider} />
                <p className={classes.title}>Plugin result: </p>
                <p className={classes.percentage}>
                    <span>{percentage}%</span> of the text appears to be AI-generated.
                </p>
            </div>
            {aiTextsContent}
        </div>
    )
}
